import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEdit = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M4 6C4 4.89543 4.89543 4 6 4H11C11.5523 4 12 4.44772 12 5C12 5.55229 11.5523 6 11 6H6V18H18V13C18 12.4477 18.4477 12 19 12C19.5523 12 20 12.4477 20 13V18C20 19.1046 19.1046 20 18 20H6C4.89543 20 4 19.1046 4 18V6Z",
		fill: "currentColor"
	}), /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M16.184 3.64121C16.965 2.86016 18.2314 2.86016 19.0124 3.64121L20.4266 5.05542C21.2077 5.83647 21.2077 7.1028 20.4266 7.88385L14.3337 13.9768C13.9541 14.3564 13.4379 14.5674 12.9011 14.5625L10.518 14.5407C9.97285 14.5357 9.53218 14.095 9.52718 13.5499L9.50532 11.1667C9.50039 10.63 9.71145 10.1138 10.091 9.73418L16.184 3.64121ZM19.0124 6.46963L17.5982 5.05542L11.5052 11.1484L11.5181 12.5498L12.9194 12.5626L19.0124 6.46963Z",
		fill: "currentColor"
	})]
});
export default SvgEdit;
